<template>
    <div class="filter-control-datepicker">
        <button 
            class="filter-control-datepicker__btn"
            :style="{width: width, height: height}"
            @click="toggleMenu"
        >
            {{selectedDatesName}}
        </button>
        <transition name="slide-fade">
            <div
                v-show="isShowMenu"
                class="filter-control-datepicker__menu"
                :style="{width: '280px'}"
            >
                <div class="filter-control-datepicker__menu-header">
                    <div 
                        class="filter-control-datepicker__menu-chevron_left"
                        :class="{
                            'filter-control-datepicker__menu-chevron_disabled': yearCurrentIndex === 0,
                            'filter-control-datepicker__menu-chevron_active': yearCurrentIndex > 0
                        }"
                        @click="onClickPrev"
                    >
                        <i class="icon-chevron-down" />
                    </div>
                    <div 
                        class="filter-control-datepicker__menu-btn_year"
                        @click="onToggleMode(null)"
                    >
                        {{typeof yearCurrent === 'undefined' ? 'нет дат' : yearCurrent}}
                    </div>
                    <div 
                        class="filter-control-datepicker__menu-chevron_right"
                        :class="{
                            'filter-control-datepicker__menu-chevron_disabled': yearCurrentIndex === (years.length - 1),
                            'filter-control-datepicker__menu-chevron_active': yearCurrentIndex < (years.length - 1)
                        }"
                        @click="onClickNext"
                    >
                        <i class="icon-chevron-down"/>
                    </div>
                </div>
                <div class="filter-control-datepicker__menu-body">
                    <fragment v-if="mode === 'month'">
                        <div 
                            v-for="(monthKey, monthKeyIndex) in monthsDefault.keys()"
                            :key="monthKeyIndex"
                            class="filter-control-datepicker__menu-item"
                            :class="{
                                'filter-control-datepicker__menu-item_default': !monthsCurrentActive.includes(monthKey) && monthsCurrentFiltered.includes(monthKey),
                                'filter-control-datepicker__menu-item_disabled': !monthsCurrentFiltered.includes(monthKey),
                                'filter-control-datepicker__menu-item_active': monthsCurrentActive.includes(monthKey)
                            }"
                            @click="onClickMonthItem(monthKey)"
                        >
                            {{monthsDefault.get(monthKey)}}
                        </div>
                    </fragment>
                    <fragment v-if="mode === 'year'">
                        <div 
                            v-for="(year, yearIndex) in years"
                            :key="yearIndex"
                            class="filter-control-datepicker__menu-item"
                            :class="{
                                'filter-control-datepicker__menu-item_default': year !== yearCurrent,
                                'filter-control-datepicker__menu-item_active': year === yearCurrent
                            }"
                            @click="onClickYearItem(yearIndex)"
                        >
                            {{year}}
                        </div>
                    </fragment>
                </div>
                <div
                    v-if="mode === 'month'"
                    class="filter-control-datepicker__menu-footer"
                >
                    <div>
                        <button
                            class="filter-control-datepicker__menu-btn_link_default"
                            :class="{
                                'filter-control-datepicker__menu-btn_link_active': isResetActive,
                                'filter-control-datepicker__menu-btn_link_disabled': !isResetActive
                            }"
                            @click="onReset"
                        >
                            Сбросить
                        </button>
                        <button
                            class="filter-control-datepicker__menu-btn_link_default"
                            :class="{
                                'filter-control-datepicker__menu-btn_link_active': isSelectCurrentYearActive,
                                'filter-control-datepicker__menu-btn_link_disabled': !isSelectCurrentYearActive
                            }"
                            @click="onSelectCurrentYear"
                        >
                            Выбрать год
                        </button>
                    </div>
                    <button 
                        class="filter-control-datepicker__menu-btn_cancel"
                        @click="hideMenu"
                    >
                        Отмена
                    </button>
                    <button 
                        class="filter-control-datepicker__menu-btn_apply"
                        @click="onChange"
                    >
                        Ок
                    </button>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import { Fragment } from 'vue-fragment'
export default {
    name: 'FilterControlDatepicker',
    components: {
        Fragment
    },
    /**
     * входные данные компонента
     * @property {object} items - элементы календаря
     * @property {array} selectedItems - выбранные элементы календаря
     * @property {string} width - ширина
     * @property {string} height - высота
     */
    props: {
        items: {
            type: Object,
            default: () => ({})
        },
        selectedItems: {
            type: Array,
            default: () => ([])
        },
        width: {
            type: String,
            default: '220px'
        },
        height: {
            type: String,
            default: '44px'
        }
    },
    /**
     * данные компонента
     * @property {boolean} isShowMenu - условие показа выпадающего меню
     * @property {array} selectedItemsBuffer - буфер выбранных значений
     * @property {Map} monthsDefault - дефолтные месяца
     * @property {number} yearCurrentIndex - индекс текущего выбранного года
     * @property {string} mode - режим календаря (выбор месяца или года)
     */
    data: () => ({
        isShowMenu: false,
        selectedItemsBuffer: [],
        monthsDefault: new Map([
            ['01', 'Янв'],
            ['02', 'Фев'],
            ['03', 'Мар'],
            ['04', 'Апр'],
            ['05', 'Май'],
            ['06', 'Июн'],
            ['07', 'Июл'],
            ['08', 'Авг'],
            ['09', 'Сен'],
            ['10', 'Окт'],
            ['11', 'Ноя'],
            ['12', 'Дек']
        ]),
        yearCurrentIndex: 0,
        mode: 'month'
    }),
    computed: {
        /**
         * заголовок для превью календаря, отражающий диапазон выбранных значений
         * @returns {string}
         */
        selectedDatesName() {
            let name = '';
            switch (this.selectedItemsBuffer.length) {
                case 0: {
                    name = "Выберите значение";
                    break;
                }
                case 1: {
                    let {year = '', month = ''} = this.convertStringIntoDate(this.selectedItemsBuffer[0]);
                    name = `${month} ${year}`
                    break;
                }
                default: {
                    let {year: firstYear = '', month: firstMonth = ''} = this.convertStringIntoDate(this.selectedItemsBuffer[0]);
                    let {year: lastYear = '', month: lastMonth = ''} = this.convertStringIntoDate(this.selectedItemsBuffer[this.selectedItemsBuffer.length - 1]);
                    name = `${firstMonth} ${firstYear}, ${lastMonth} ${lastYear}`;
                    break;
                }
            }
            return name;
        },
        /**
         * все доступные года
         * @returns {array}
         */
        years() {
            let years = [];
            let dateKeys = Object.keys(this.items);
            dateKeys.forEach((date) => {
                let {year = ''} = this.convertStringIntoDate(date);
                if (!years.includes(year))
                   years.push(year);
            });
            return years;
        },
        /**
         * текущий выбранный год
         * @returns {string}
         */
        yearCurrent() {
            return this.years[this.yearCurrentIndex] || 'нет дат';
        },
        /**
         * доступные месяца текущего года
         * @returns {array}
         */
        monthsCurrentFiltered() {
            let monthsCurrentFiltered = [];
            let datesKeys = Object.keys(this.items);
            this.monthsDefault.forEach((value, key) => {
                let dateFormatted = this.convertDateIntoString(this.yearCurrent, key);
                if (datesKeys.includes(dateFormatted))
                    monthsCurrentFiltered.push(key);
            });
            return monthsCurrentFiltered;
        },
        /**
         * активные месяца текущего года
         * @returns {array}
         */
        monthsCurrentActive() {
            let monthsCurrentActive = [];
            this.monthsCurrentFiltered.forEach((month) => {
                let dateFormatted = this.convertDateIntoString(this.yearCurrent, month);
                if (this.selectedItemsBuffer.includes(dateFormatted)) {
                    monthsCurrentActive.push(month);
                }
            });
            return monthsCurrentActive;
        },
        /**
         * активные месяца текущего года из пропса selectedItems
         * @returns {array}
         */
        monthsCurrentActiveProps() {
            let monthsCurrentActiveProps = [];
            this.monthsCurrentFiltered.forEach((month) => {
                let dateFormatted = this.convertDateIntoString(this.yearCurrent, month);
                if (this.selectedItems.includes(dateFormatted)) {
                    monthsCurrentActiveProps.push(month);
                }
            });
            return monthsCurrentActiveProps;
        },
        /**
         * условие активности кнопки сбросить
         * @returns {boolean}
         */
        isResetActive() {
            let dateKeys = Object.keys(this.items);
            let maxDate = dateKeys[dateKeys.length - 1];
            return this.selectedItemsBuffer.length !== 1 || this.selectedItemsBuffer[0] !== maxDate;
        },
        /**
         * условие активности кнопки выбрать год
         * @returns {boolean}
         */
        isSelectCurrentYearActive() {
            return this.monthsCurrentFiltered.length !== this.monthsCurrentActive.length
        }
    },
    watch: {
        /**
         * если изменились выбранные данные - перезаписать буффер
         */
        selectedItems: function () {
            this.selectedItemsBuffer = this.sortDatesString(this.selectedItems.slice());
        }
    },
    mounted() {
        // заносим входные параметры в буффер
        this.selectedItemsBuffer = this.sortDatesString(this.selectedItems.slice());
    },
    methods: {
        /**
         * перевести строку в объект даты
         * @param {string} date
         * @returns {object}
         */
        convertStringIntoDate(date) {
            let dateSplitArr = String(date).split('-');
            let dateSplitObj = {
                year: dateSplitArr[0],
                month: this.monthsDefault.get(dateSplitArr[1])
            };
            return dateSplitObj;  
        },
        /**
         * перевести объект даты в строку
         * @param {string} year - год
         * @param {string} month - месяц
         * @returns {string}
         */
        convertDateIntoString(year, month) {
            return `${year}-${month}-01`
        },
        /**
         * функция сортировки массива дат в виде строк
         * @param {array} dates - даты
         * @returns {array}
         */
        sortDatesString(dates) {
            let sortedDates = dates.sort((dateA, dateB) => {
                let dateSplitA = String(dateA).split('-');
                let dateSplitB = String(dateB).split('-');
                if (Number(dateSplitA[0]) > Number(dateSplitB[0]))
                    return 1;
                else if (Number(dateSplitA[0]) < Number(dateSplitB[0]))
                    return -1;
                else if (Number(dateSplitA[1]) > Number(dateSplitB[1]))
                    return 1;
                else if (Number(dateSplitA[1]) < Number(dateSplitB[1]))
                    return -1;
                return 0;
            });
            return sortedDates;
        },
        /**
         * переключить отображение меню
         */
        toggleMenu() {
            if (this.isShowMenu)
                this.hideMenu();
            else
                this.showMenu();
        },
        /**
         * показать меню
         */
        showMenu() {
            this.isShowMenu = true;
            document.addEventListener('click', this.clickOutSide);
        },
        /**
         * скрыть меню
         */
        hideMenu() {
            this.isShowMenu = false;
            this.selectedItemsBuffer = this.selectedItems.slice();
            document.removeEventListener('click', this.clickOutSide);
        },
        /**
         * слушаем зарегестрированное событие на dom
         * проверяем клик вне элемента
         * @param {object} event - объект события
         */
        clickOutSide(event) {
            let element = event.target;
            if (!this.$el.contains(element))
               this.hideMenu(); 
        },
        /**
         * событие клика по кнопке предыдущий год
         */
        onClickPrev() {
            if (this.yearCurrentIndex !== 0) {
                this.onToggleMode('month');
                this.yearCurrentIndex -= 1;
            }
        },
        /**
         * событие клика по кнопке следующий год
         */
        onClickNext() {
            if (this.yearCurrentIndex !== this.years.length - 1) {
                this.onToggleMode('month');
                this.yearCurrentIndex += 1;
            }
        },
        /**
         * событие клика по элементу календаря
         * удалить или добавить в выбранное
         * @param {string} monthKey - ключ месяца
         */
        onClickMonthItem(monthKey) {
            let dateFormatted = this.convertDateIntoString(this.yearCurrent, monthKey);
            if (this.selectedItemsBuffer.includes(dateFormatted)) {
                let dateRemoveIndex = this.selectedItemsBuffer.findIndex(date => date === dateFormatted);
                this.selectedItemsBuffer.splice(dateRemoveIndex, 1);
            }
            else {
                this.selectedItemsBuffer.push(dateFormatted);
                this.selectedItemsBuffer = this.sortDatesString(this.selectedItemsBuffer.slice());
            }
        },
        /**
         * событие клика по элементу доступных годов
         * @param {number} yearIndex - индекс года
         */
        onClickYearItem(yearIndex) {
            this.yearCurrentIndex = yearIndex;
            this.onToggleMode('month');
        },
        /**
         * переключить режим календаря
         * @param {string} mode - режим календаря
         */
        onToggleMode(mode = null) {
            if (mode === null)
                this.mode = this.mode === 'month' ? 'year' : 'month';
            else 
                this.mode = mode;
        },
        /**
         * событие выбора года
         */
        onSelectCurrentYear() {
            let selectedItemsBuffer = [];
            this.monthsCurrentFiltered.forEach((month) => {
                let dateFormatted = this.convertDateIntoString(this.yearCurrent, month);
                if (!selectedItemsBuffer.includes(dateFormatted)) {
                    selectedItemsBuffer.push(dateFormatted);
                    selectedItemsBuffer = this.sortDatesString(selectedItemsBuffer.slice());
                }
            });
            this.selectedItemsBuffer = selectedItemsBuffer.slice();
        },
        /**
         * событие сбросить
         */
        onReset() {
            const itemsDates = Object.keys(this.items).map(item => new Date(item));
            const temp = itemsDates.map(d => Math.abs(new Date() - new Date(d)));
            const idx = temp.indexOf(Math.min(...temp));
            const resetDate = itemsDates[idx].toLocaleDateString();
            const resetDateFormatted = resetDate.split('.').reverse().join('-');
            this.selectedItemsBuffer = [resetDateFormatted];
        },
        /**
         * изменить выбор
         */
        onChange() {
            let isEqual = this.isEqual(this.selectedItems.slice(), this.selectedItemsBuffer.slice());
            if (!isEqual) {
                this.$emit('onChange', this.selectedItemsBuffer);
            }
            this.hideMenu();
        },
        /**
         * проверка эквивалентности массивов
         * @property {array} arr1 - первый массив
         * @property {array} arr2 - второй массив
         * @returns {boolean}
         */
        isEqual(arr1, arr2) {
            let sortedArr1 = this.sortDatesString(arr1.slice());
            let sortedArr2 = this.sortDatesString(arr2.slice());
            let isEqualLength = sortedArr1.length == sortedArr2.length;
            let isEqualValues = sortedArr1.every((value, index) => value === sortedArr2[index]);
            return isEqualLength && isEqualValues;
        }
    }
}
</script>

<style lang="scss" scoped>
    .slide-fade-enter-active {
        transition: all 0.3s ease;
    }
    .slide-fade-leave-active {
        transition: all 0.2s ease;
    }
    .slide-fade-enter {
        transform: translateY(-20px);
        opacity: 0;
    }
    .slide-fade-leave-to {
        transform: translateY(-20px);
        opacity: 0;
    }
    .filter-control-datepicker__btn {
        margin: 0 10px 13px 0;
        cursor: pointer;
        padding: 5px 10px;
        background: #f1f3f5;
        border-radius: 4px;
        border: 1px solid transparent;
    }
    .filter-control-datepicker__btn:hover {
        transition: .3s;
        border-color: #fe1060;
    }
    .filter-control-datepicker__btn:focus {
        outline: 0;
    }
    .filter-control-datepicker__menu {
        z-index: 9;
        background: #fff;
        position: absolute;
        min-width: 150px;
        box-shadow: 7px 5px 20px rgba(34,44,54,.15);
        border-radius: 5px;
    }
    .filter-control-datepicker__menu:before {
        content: "";
        position: absolute;
        display: block;
        border: 9px solid transparent;
        border-bottom-color: #fff;
        z-index: 999;
        left: 10px;
        top: -18px;
    }
    .filter-control-datepicker__menu-header {
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-between;
        align-items: center;
        text-align: center;
        padding: 10px 20px;
    }
    %filter-control-datepicker__menu-chevron {
        font-size: 0.3846rem;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 32px;
        height: 32px;
    }
    .filter-control-datepicker__menu-chevron_active {
        cursor: pointer;
    }
    .filter-control-datepicker__menu-chevron_active:hover {
        color: #fe1060;
    }
    .filter-control-datepicker__menu-chevron_disabled {
        color: #b0b1b4;
    }
    .filter-control-datepicker__menu-chevron_left {
        @extend %filter-control-datepicker__menu-chevron;
        transform: rotate(90deg);
    }
    .filter-control-datepicker__menu-chevron_right {
        @extend %filter-control-datepicker__menu-chevron;
        transform: rotate(-90deg);
    }
    .filter-control-datepicker__menu-btn_year {
        cursor: pointer;
    }
    .filter-control-datepicker__menu-btn_year:hover {
        color: #fe1060;
    }
    .filter-control-datepicker__menu-body {
        display: flex;
        flex-flow: row wrap;
        // justify-content: space-between;
        justify-content: flex-start;
        align-items: stretch;
        padding: 10px 20px;
    }
    .filter-control-datepicker__menu-item {
        flex-grow: 1;
        // width: 30%;
        width: 70px;
        display: flex;
        border-radius: 100px;
        border: 1px solid transparent;
        height: 36px;
        align-items: center;
        text-align: center;
        justify-content: center;
        transition: all 250ms;
        margin: 2px;
        cursor: pointer;
    }
    .filter-control-datepicker__menu-item_default:hover {
        color: #fe1060;
        border-color: #fe1060;
    }
    .filter-control-datepicker__menu-item_disabled {
        color: #b0b1b4;
        pointer-events: none;
    }
    .filter-control-datepicker__menu-item_active {
        color: #000;
        background: #fe1060;
    }
    .filter-control-datepicker__menu-item_active:hover {
        background: #d00146;
    }
    .filter-control-datepicker__menu-footer {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding: 10px 20px;
        pointer-events: auto;
    }
    %filer-control-dropdown__menu-btn {
        cursor: pointer;
        pointer-events: auto;
        height: 32px;
        width: min-content;
        padding: 4px 14px;
        border-radius: 100px;
        transition: .3s;
        border: 1px solid transparent;
        outline: none;
    }
    .filter-control-datepicker__menu-btn_link_default {
        border: 0;
        background: none;
        outline: none;
    }
    .filter-control-datepicker__menu-btn_link_active {
        cursor: pointer;
    }
    .filter-control-datepicker__menu-btn_link_disabled {
        color: #b0b1b4;
        pointer-events: none;
    }
    .filter-control-datepicker__menu-btn_link_active:hover {
        transition: 0.3s;
        color: #fe1060;
    }
    .filter-control-datepicker__menu-btn_cancel {
        @extend %filer-control-dropdown__menu-btn;
        color: #9b9b9b;
    }
    .filter-control-datepicker__menu-btn_cancel:hover {
        color: #fe1060;
        border-color: #fe1060;
    }
    .filter-control-datepicker__menu-btn_apply {
        @extend %filer-control-dropdown__menu-btn;
        margin-left: 5px;
        color: #000;
        background: #fe1060;
    }
    .filter-control-datepicker__menu-btn_apply:hover {
        background: #d00146;
    }
</style>